// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"8e7ae63c","385":"a9ed6a95","654":"06055740","672":"ec1af15b","712":"e552d5f1","853":"bd9d8970","920":"42c018e4"}[chunkId] + ".chunk.js";
};